<template>
    <div style="height: 100vh;overflow: scroll">

        <div style="padding: 10px">
            <el-row class="gongnengBtn">
                <el-col :span="4" >            <el-button type="success" @click="abc0 =true , abc1 = !abc0,abc2 = !abc0,abc3 = !abc0,abc4 = !abc0 ">{{gongneng[0]}}</el-button></el-col>
                <el-col :span="4" :offset="1" ><el-button type="success" @click="abc1 =true , abc0 = !abc1,abc2 = !abc1,abc3 = !abc1,abc4 = !abc1 ">{{gongneng[1]}}</el-button></el-col>
                <el-col :span="4" :offset="1" ><el-button type="success" @click="abc2 =true , abc0 = !abc2,abc1 = !abc2,abc3 = !abc2,abc4 = !abc2 ">{{gongneng[2]}}</el-button></el-col>
                <el-col :span="4" :offset="1" ><el-button type="success" @click="abc3 =true , abc0 = !abc3,abc1 = !abc3,abc2 = !abc3,abc4 = !abc3 ">{{gongneng[3]}}</el-button></el-col>
                <el-col :span="4" :offset="1" ><el-button type="success" @click="abc4 =true , abc0 = !abc4,abc1 = !abc4,abc2 = !abc4,abc3 = !abc4 ">{{gongneng[4]}}</el-button></el-col>
            </el-row>
            <div style="padding: 10px">

<!--                公司简介-->
                <div v-show="abc0">
                    <gongsijianjie />
                </div>
                <div v-show="abc1">
                    <gongsirongyu />
                </div>
                <div v-show="abc2">
                   <fazhanlicheng />
                </div>
                <div v-show="abc3">
                    <yinsitiaokuan />
                </div>
                <div v-show="abc4">
                    <lianxiwomen />
                </div>

            </div>

        </div>



    </div>
</template>

<script>

    import Gongsijianjie from "@/login/success/About/gongsijianjie";
    import Gongsirongyu from "@/login/success/About/gongsirongyu";
    import Fazhanlicheng from "@/login/success/About/fazhanlicheng";
    import Yinsitiaokuan from "@/login/success/About/yinsitiaokuan";
    import Lianxiwomen from "@/login/success/About/lianxiwomen";

    export default {
        name: "login",
        components: {Gongsijianjie,Gongsirongyu,Fazhanlicheng,Yinsitiaokuan,Lianxiwomen},
        metaInfo: {
            title: 'Ifcores 管理中心 - 关于我们 | 南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '后台管理',
                content: '后台管理系统，管理数据和功能'
            }]
        },
        data() {
           return{
               gongneng:["公司简介","荣誉资质","发展历程","隐私条款","联系我们"],
               abc0:true,
               abc1:false,
               abc2:false,
               abc3:false,
               abc4:false,


           }

        },
        methods:{




        },



    }
</script>

<style scoped lang="less">
    .gongnengBtn{
        .el-col{
            margin-top: 20px;
            text-align: center;
            height: 80px;
            line-height: 80px;
            font-size: 20px;


            .el-button:hover{
                background-color: #ffffff;
                color:#000000;
            }
        }
    }


</style>